import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';

import { CustomBreadcrumbComponent } from './breadcrumb.component';

@NgModule({
  declarations: [CustomBreadcrumbComponent],
  imports: [CommonModule, MatIconModule, MatMenuModule, RouterModule],
  exports: [CustomBreadcrumbComponent],
})
export class CustomBreadcrumbModule {}
